module.exports = __webpack_public_path__ + "static/img/title_img.85677fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/new_years_day/title_img.png
// module id = dyJS
// module chunks = 1